import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "aside-primary d-flex flex-column align-items-lg-center flex-row-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "aside-logo d-lg-flex flex-column justify-content-center align-items-center flex-column-auto py-10",
  id: "kt_aside_logo"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "/media/logos/logo.png",
    class: "h-70px"
  })
], -1)
const _hoisted_3 = {
  class: "aside-nav d-flex flex-column align-items-center flex-column-fluid w-100 pt-5 pt-lg-0",
  id: "kt_aside_nav"
}
const _hoisted_4 = {
  class: "hover-scroll-y mb-10",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_aside_nav",
  "data-kt-scroll-dependencies": "#kt_aside_logo, #kt_aside_footer",
  "data-kt-scroll-offset": "0px"
}
const _hoisted_5 = { class: "nav flex-column" }
const _hoisted_6 = {
  key: 0,
  class: "nav-item mb-2",
  "data-bs-toggle": "tooltip",
  "data-bs-trigger": "hover",
  "data-bs-placement": "right",
  "data-bs-dismiss": "click",
  title: "Admin",
  "data-bs-original-title": "Admin",
  style: {"margin-left":"26px"}
}
const _hoisted_7 = { class: "svg-icon svg-icon-2x" }
const _hoisted_8 = { class: "svg-icon svg-icon-3x" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-2",
  style: {"font-weight":"400","color":"#181C32"}
}, " Dashboard ", -1)
const _hoisted_10 = {
  key: 2,
  class: "nav-item mb-2"
}
const _hoisted_11 = { class: "svg-icon svg-icon-3x" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-2",
  style: {"font-weight":"400","color":"#181C32"}
}, " Account ", -1)
const _hoisted_13 = {
  key: 3,
  class: "nav-item mb-2"
}
const _hoisted_14 = { class: "svg-icon svg-icon-3x" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-2",
  style: {"font-weight":"400","color":"#181C32"}
}, " Account ", -1)
const _hoisted_16 = {
  class: "aside-footer d-flex flex-column align-items-center flex-column-auto",
  id: "kt_aside_footer"
}
const _hoisted_17 = {
  class: "flex-column-auto mb-5",
  id: "kt_aside_secondary_footer"
}
const _hoisted_18 = { class: "mb-0" }
const _hoisted_19 = { class: "symbol symbol-100px" }
const _hoisted_20 = { class: "symbol-label" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!
  const _component_KTSimulatedUserMenu = _resolveComponent("KTSimulatedUserMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: "/admin/users",
                  class: "nav-link btn btn-icon btn-active-color-primary btn-active-light"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(_component_inline_svg, {
                        src: "/media/icons/duotune/general/gen049.svg",
                        "aria-hidden": "true"
                      })
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("h1", null, _toDisplayString(_ctx.simulatedUser), 1),
          (
              !_ctx.isAdmin ||
              (_ctx.isAdmin && _ctx.user_id)
            )
            ? (_openBlock(), _createElementBlock("li", {
                key: 1,
                class: "nav-item mb-2",
                "data-bs-toggle": "tooltip",
                "data-bs-trigger": "hover",
                "data-bs-placement": "right",
                "data-bs-dismiss": "click",
                title: "Dashboard",
                "data-bs-original-title": "Dashboard",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickSidebarLink('dashboard')))
              }, [
                _createVNode(_component_router_link, {
                  id: "sidebar-dashboard-link",
                  to: _ctx.isAdmin ? `/admin/${_ctx.user_id}/dashboard` : '/dashboard',
                  class: _normalizeClass(_ctx.getDashboardLinkClass())
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_component_inline_svg, {
                        id: "dashboard-icon",
                        src: "/media/vectorial/dashboard.svg",
                        "aria-hidden": "true"
                      })
                    ]),
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["to", "class"])
              ]))
            : _createCommentVNode("", true),
          (
              !_ctx.isAdmin ||
              (_ctx.isAdmin && _ctx.route.path === '/admin/users')
            )
            ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                _createElementVNode("a", {
                  id: "sidebar-account-link",
                  class: _normalizeClass(_ctx.getAccountLinkClass()),
                  href: "javascript:void(0)",
                  "data-kt-menu-trigger": "click",
                  "data-kt-menu-overflow": "true",
                  "data-kt-menu-placement": "right-start",
                  "data-kt-menu-flip": "top-end",
                  "data-bs-toggle": "tooltip",
                  "data-bs-placement": "right",
                  "data-bs-dismiss": "click",
                  title: "User profile",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickSidebarLink('account')))
                }, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_inline_svg, {
                      id: "account-icon",
                      src: "/media/vectorial/account.svg",
                      "aria-hidden": "true"
                    })
                  ]),
                  _hoisted_12
                ], 2),
                _createVNode(_component_KTUserMenu)
              ]))
            : (_openBlock(), _createElementBlock("li", _hoisted_13, [
                _createElementVNode("a", {
                  id: "sidebar-account-link",
                  class: _normalizeClass(_ctx.getAccountLinkClass()),
                  href: "javascript:void(0)",
                  "data-kt-menu-trigger": "click",
                  "data-kt-menu-overflow": "true",
                  "data-kt-menu-placement": "right-start",
                  "data-kt-menu-flip": "top-end",
                  "data-bs-toggle": "tooltip",
                  "data-bs-placement": "right",
                  "data-bs-dismiss": "click",
                  title: "User profile"
                }, [
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_inline_svg, {
                      id: "account-icon",
                      src: "/media/vectorial/account.svg",
                      "aria-hidden": "true"
                    })
                  ]),
                  _hoisted_15
                ], 2),
                _createVNode(_component_KTSimulatedUserMenu)
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", _hoisted_20, [
              _createVNode(_component_inline_svg, {
                class: "w-100 align-self-center",
                src: "/media/vectorial/valored_logo.svg",
                alt: _ctx.translate('VALORED_PROJECT_LOGO'),
                title: _ctx.translate('VALORED_PROJECT_LOGO'),
                "aria-label": _ctx.translate('VALORED_PROJECT_LOGO')
              }, null, 8, ["alt", "title", "aria-label"])
            ])
          ]),
          _hoisted_21
        ])
      ])
    ])
  ]))
}